import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import Logo from "@/components/Logo";

export default function Signup() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/register", form);
      localStorage.setItem("trustline_token", r.data.token);
      await login(form.email, form.password);
      toast.success(t("auth_page.welcome", { name: form.name }));
      nav("/my-account");
    } catch (err) {
      toast.error(formatError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-appBg px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Link to="/"><Logo className="h-10" /></Link></div>
        <div className="bg-white rounded-2xl p-8 ring-1 ring-slate-200 shadow-sm">
          <h1 className="font-heading text-2xl font-bold text-[#1B3A6B]">{t("auth_page.signup_title")}</h1>
          <p className="mt-1 text-sm text-slate-500">{t("auth_page.signup_subtitle")}</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label>{t("auth_page.full_name")}</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className="mt-1.5" data-testid="signup-name" /></div>
            <div><Label>{t("auth_page.email")}</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="mt-1.5" data-testid="signup-email" /></div>
            <div><Label>{t("auth_page.phone")}</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+31 …" className="mt-1.5" data-testid="signup-phone" /></div>
            <div><Label>{t("auth_page.password")}</Label><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required className="mt-1.5" data-testid="signup-password" /></div>
            <Button type="submit" disabled={busy} className="w-full bg-[#1B3A6B] hover:bg-[#152D54] text-white rounded-full font-semibold h-11" data-testid="signup-submit">
              {busy ? t("auth_page.creating") : t("auth_page.create")}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-slate-500">
            {t("auth_page.have_account")} <Link to="/login" className="text-[#1B3A6B] font-semibold">{t("auth_page.sign_in")}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
